export const CIRCUITS = [
    {
        id: 0,
        name: "Cruiserweight Elite Circuit",
        roundsPerMatch: 5,
        opponents: [
            {
                id: 0,
                incompetence: 90,
                hp: 50,
                name: "Gris&aacute;ceo Sieger",
                description: "Victory: not always black &amp; white, sometimes it's gray.",
                rank: 3,
                ethnicity: "German-Chilean",
                from: "USA",
                age: 50,
                weight: 183,
                food: "Berliners",
                wins: 1,
                losses: 33,
                kos: 1,
                tkos: 0,
                sayings: [
                    "Grrrr. Affected me deeply?",
                    "&iexcl;No hay problema! Gray, pero here to stay!",
                    "Like ein Berliner? Nein, nicht so sweet.",
                    "Be like water - Delugeonal!"
                ]
            },
            {
                id: 1,
                incompetence: 70,
                hp: 60,
                name: "Loquito Carlito",
                description: "Genius or Madness?...Why not both?",
                rank: 2,
                ethnicity: "Filipino",
                from: "USA",
                age: 30,
                weight: 168,
                food: "Chocolate peanut butter lumpia",
                wins: 5,
                losses: 5,
                kos: 0,
                tkos: 0,
                sayings: [
                    "Payonpah!",
                    "Psy ay ay...",
                    "My cabbages!",
                    "NO. MORE. SPROUTS."
                ]
            },
            {
                id: 2,
                incompetence: 50,
                hp: 70,
                name: "Andre the Uncompliant",
                description: "Here's a game for ya, 52 card pickup!  HA HA!",
                rank: 1,
                ethnicity: "Mexican",
                from: "USA",
                age: 29,
                weight: 198,
                food: "Flan",
                wins: 18,
                losses: 2,
                kos: 8,
                tkos: 1,
                sayings: [
                    "NEMESISSSSSSS!",
                    "Fight fair. No screen-looking!",
                    "It's gonna slam like flan!",
                    "You can't stop the Uncompliant!"
                ]
            }
        ]
    },
    {
        id: 1,
        name: "Middleweight Championship Circuit",
        roundsPerMatch: 7,
        opponents: [
            {
                id: 0,
                incompetence: 100,
                hp: 0,
                name: "TBD",
                description: "TBD",
                rank: 3,
                ethnicity: "TBD",
                from: "TBD",
                age: 0,
                weight: 0,
                food: "TBD",
                wins: 0,
                losses: 0,
                kos: 0,
                tkos: 0,
                sayings: [
                    "TBD",
                    "TBD",
                    "TBD",
                    "TBD"
                ]
            },
            {
                id: 1,
                incompetence: 100,
                hp: 0,
                name: "TBD",
                description: "TBD",
                rank: 2,
                ethnicity: "TBD",
                from: "TBD",
                age: 0,
                weight: 0,
                food: "TBD",
                wins: 0,
                losses: 0,
                kos: 0,
                tkos: 0,
                sayings: [
                    "TBD",
                    "TBD",
                    "TBD",
                    "TBD"
                ]
            },
            {
                id: 2,
                incompetence: 100,
                hp: 0,
                name: "TBD",
                description: "TBD",
                rank: 1,
                ethnicity: "TBD",
                from: "TBD",
                age: 0,
                weight: 0,
                food: "TBD",
                wins: 0,
                losses: 0,
                kos: 0,
                tkos: 0,
                sayings: [
                    "TBD",
                    "TBD",
                    "TBD",
                    "TBD"
                ]
            }
        ]
    },
    {
        id: 2,
        name: "Heavyweight World Circuit",
        roundsPerMatch: 12,
        opponents: [
            {
                id: 0,
                incompetence: 100,
                hp: 0,
                name: "TBD",
                description: "TBD",
                rank: 3,
                ethnicity: "TBD",
                from: "TBD",
                age: 0,
                weight: 0,
                food: "TBD",
                wins: 0,
                losses: 0,
                kos: 0,
                tkos: 0,
                sayings: [
                    "TBD",
                    "TBD",
                    "TBD",
                    "TBD"
                ]
            },
            {
                id: 1,
                incompetence: 100,
                hp: 0,
                name: "TBD",
                description: "TBD",
                rank: 2,
                ethnicity: "TBD",
                from: "TBD",
                age: 0,
                weight: 0,
                food: "TBD",
                wins: 0,
                losses: 0,
                kos: 0,
                tkos: 0,
                sayings: [
                    "TBD",
                    "TBD",
                    "TBD",
                    "TBD"
                ]
            },
            {
                id: 2,
                incompetence: 100,
                hp: 0,
                name: "TBD",
                description: "TBD",
                rank: 1,
                ethnicity: "TBD",
                from: "TBD",
                age: 0,
                weight: 0,
                food: "TBD",
                wins: 0,
                losses: 0,
                kos: 0,
                tkos: 0,
                sayings: [
                    "TBD",
                    "TBD",
                    "TBD",
                    "TBD"
                ]
            }
        ]
    }
];
